import 'zone.js';
import 'reflect-metadata'
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { UserComponent } from '../app/component/user/user.component';
import { AppComponent } from './app.component';
import { SideBarComponent } from './shared/side-bar/side-bar.component';
import { UserService } from './services/user.service';
import { AuthenticationService } from './services/authentication.service';
import { AdministrateurCompanyModule } from './component/administrateur-company/administrateur-company.module';
import { ADMINISTRATION_COMPANY_ROUTES } from './component/administrateur-company/administrateur-company.routes';
import { HomeComponent } from './corp/home/home.component';
import { CorpModule } from './corp/corp.module';
import { CorpRoutes } from './corp/corp.routes';
import { HeaderModule } from './shared/header/header.module';
import { StatiqueService } from './services/statique.service';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { ToastOptions } from 'ng2-toastr/src/toast-options';
import { EtablissementService } from './services/etablissement.service';
import { NgUploaderModule } from 'ngx-uploader';

import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { EqualValidator } from './utils/equal-validator.directive';

import { appRouter } from './app.routes';
import { InscriptionService } from './services/inscription.service';
import { SharedModule } from './shared/module/shared.module';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TOKEN_NAME } from './services/auth.constant';
import { generaleMethodes } from './shared/generaleMethodes.component';
import { PricingComponent } from './component/pricing-booking/pricing/pricing.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AdvancedSearchModule } from './shared/advanced-search/advanced-search.module';
import { SavedFormsModule } from './component/saved-forms/saved-forms.module';
import { ArchwizardModule } from 'ng2-archwizard';
import { DialogsModule } from './shared/dialogs/dialog.module';
import { SavedSearchComponent } from './component/saved-forms/saved-search/saved-search.component';
import { DemandeprefereComponent } from './component/saved-forms/demandeprefere/demandeprefere.component';
import { HistoryComponent } from './component/saved-forms/history/history.component';
import { ExportService } from './services/export.service';
import { ModalService } from './shared/modal/modal.service';
import { CompagnieService } from './services/compagnie.service';
import { TransportManagementComponent } from './component/pricing-booking/transport-management/transport-management.component';
import { AdressesComponent } from './component/user/settings/my-company/adresses/adresses.component';
import { UserAuthGuardService } from './services/user-auth-guard.service';
import { AccountComponent } from './component/account/account.component';
import { LoginComponent } from './component/account/login/login.component';
import { ResetPasswordComponent } from './component/account/login/reset-password/reset-password.component';
import { CarrousselAccountComponent } from './component/account/carroussel-account/carroussel-account.component';
import { PricingBookingComponent } from './component/pricing-booking/pricing-booking.component';
import { PricingBookingResponsiveComponent } from './component/pricing-booking-responsive/pricing-booking.component';
import { SharedComponentComponent } from './component/pricing-booking/shared-component/shared-component.component';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { FreightAuditService } from './services/freight-audit.service';
import { FavoriService } from './services/favori.service';
import { QualityManagementService } from './services/quality-mangement.service.';
import { TrackTraceService } from './services/trackTrace.service';
import { environment } from '../environments/environment';
// import { TagInputModule } from 'ngx-chips';
import { dockManagement } from './component/dock-management/dock-management.component';
import { dockManagementModule } from './component/dock-management/dock-management.module';
import { ModalEventComponent } from './component/track-trace/shared-components/modal-event/modal-event.component';
import { MotifService } from './services/motif.service';
import { DashboardComponent } from './component/dashboard/dashboard.component';


export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
};

export function authHttpServiceFactory(http: Http) {
	return new AuthHttp(new AuthConfig({
		headerPrefix: 'Bearer',
		tokenName: TOKEN_NAME,
		globalHeaders: [{ 'Content-Type': 'application/json' }],
		noJwtError: false,
		noTokenScheme: true,
		tokenGetter: (() => localStorage.getItem(TOKEN_NAME))
	}), http);
}

export class CustomOption extends ToastOptions {
	toastLife = 15000;
	showCloseButton = true;
	enableHTML = true;
}

@NgModule({
	declarations: [
		AppComponent,
		LoginComponent,
		ResetPasswordComponent,
		SideBarComponent,
		PricingComponent,
		DemandeprefereComponent,
		SavedSearchComponent,
		HistoryComponent,
		TransportManagementComponent,
		AccountComponent,
		PricingBookingComponent,
		PricingBookingResponsiveComponent,
		SharedComponentComponent,
		DashboardComponent,
		
	],

	imports: [
		HttpModule,
		BrowserModule,
		BrowserAnimationsModule,
		NoopAnimationsModule,
		NgSelectModule,
		ArchwizardModule,
		ToastModule.forRoot(),
		NgbModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		appRouter,
		HeaderModule,
		CorpModule,
		HttpClientModule,
		SharedModule,
		AdvancedSearchModule,
		SavedFormsModule,
		DialogsModule,
		dockManagementModule,
	NgxPageScrollModule,

    // TagInputModule,
	],


	providers: [
		{ provide: AuthHttp, useFactory: authHttpServiceFactory, deps: [Http] },
		{ provide: ToastOptions, useClass: CustomOption },
		InscriptionService,
		AuthenticationService,
		UserService,
		StatiqueService,
		EtablissementService,
		DatePipe,
		generaleMethodes,
		ExportService,
		ModalService,
		NgbActiveModal,
		CompagnieService,
		UserAuthGuardService,
		FreightAuditService,
    	FavoriService,
		QualityManagementService,
		TrackTraceService,
		MotifService
	],
	bootstrap: [AppComponent]
})
export class AppModule {

  constructor() {
    console.log('Base Api :' + environment.apiUrl +
         ' production? ' +  environment.production +
         ' env: ' + environment.envName);
 }
 }



// WEBPACK FOOTER //
// ./src/app/app.module.ts